import { useGetAnalysisFromURL } from '@modules/analysis/hooks/useGetAnalysisFromURL';
import { AnalysisStoreProvider } from '@modules/analysis/store/AnalysisStoreProvider';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import {
  NAV_PATHS,
  NOTIFICATION_TIMEOUT_LONG_6S,
} from '@modules/common/constants';
import { QuantifyStoreProvider } from '@modules/quantify/store/QuantifyStoreProvider';
import { Typography } from '@mui/material';
import { AnalysisUseCase, Status } from 'generated/graphql';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import useFullscreenLoader from 'v2/core/services/loader/useFullscreenLoader';
import { SavedQuantifyAnalysis } from './SavedQuantifyAnalysis';

export function SavedQuantifyAnalysisIndex() {
  const { showNotification } = useNotificationContext();

  const { showErrorNotification } = useNotificationContext();
  const { data, status, error } = useGetAnalysisFromURL();

  const isLoading = IsLoading(status);

  useEffect(() => {
    if (error) {
      showErrorNotification({
        contentComponent: `Failed to fetch Quantify.`,
        props: { isClosable: true },
      });
    }
  }, [error, showErrorNotification]);

  const navigate = useNavigate();

  useEffect(() => {
    if (data?.status === Status.Archived) {
      showNotification({
        contentComponent: 'This Quantify is archived.',
        props: {
          timeout: NOTIFICATION_TIMEOUT_LONG_6S,
          severity: 'info',
        },
      });
      navigate(`/${NAV_PATHS.QUANTIFY}`);
    }
  }, [data?.status, navigate, showNotification]);

  useFullscreenLoader({
    isLoading,
    isInvisible: true,
  });

  if (error) {
    return <Typography color="error">Failed to fetch Quantify</Typography>;
  }

  if (isLoading) {
    return null;
  }

  return (
    <AnalysisStoreProvider useCase={AnalysisUseCase.Default}>
      <QuantifyStoreProvider>
        <SavedQuantifyAnalysis data={data} />
      </QuantifyStoreProvider>
    </AnalysisStoreProvider>
  );
}
